import { ErrorMessage } from 'formik';

export default function ErrorMsg(props) {
  return <ErrorMessage {...props} component="div" className="error" />;
}
